import { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext({ get: (k, f) => f, ready: false });

export const useSiteContent = () => useContext(Ctx);

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setContent)
      .catch(() => setContent({}));
  }, []);

  const get = (key, fallback) => (content && content[key] !== undefined ? content[key] : fallback);

  return <Ctx.Provider value={{ get, ready: content !== null }}>{children}</Ctx.Provider>;
};
